export default "__VITE_PUBLIC_ASSET__731475f9__"